import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { MFReports } from "../../Configuration/API_URL";
import Header from "../../Components/Header";
import ReportTableHeader from "../../Components/ReportTables/ReportTableHeader";
import Loader from "../../Components/Common/Loader";
import {
  AESEncryption,
  ApiResDecrypt,
  getCurrentFinancialYear,
  noDataFound,
} from "../../CommonMethhods/CommonMethods";
import { Constants } from "../../CommonMethhods/Constants";
import { toast } from "react-toastify";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import axiosInstance from "../../CommonMethhods/axiosInstance";
import MFElssReportTable from "../../Components/ReportTables/MFElssReportTable";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import CommonSearch from "../../CommonMethhods/CommonSearch";
import MFCapitalGainReportTable from "../../Components/ReportTables/MFCapitalGainReportTable";

function MfCapitalGainReportSidebar() {

  const today = new Date();
      const currentFinYearStart = new Date(
        getCurrentFinancialYear(today).startDate
      );
      const frstVal = new Date(
        currentFinYearStart.getFullYear(),
        currentFinYearStart.getMonth(),
        1
      );

  const frstDay = moment(frstVal, "MM-DD-YYYY").format("YYYY-MM-DD");
  const lstVal = new Date();
  const lstDay = moment(lstVal, "MM-DD-YYYY").format("YYYY-MM-DD");

  const [fromDate, setFromDate] = useState(frstDay);
  const [toDate, setToDate] = useState(lstDay);
  const [errorGrid, setErrorGrid] = useState(false);
  const [serverError, setServerError] = useState("");
  const [loader, setLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [clientCode, setClientCode] = useState("");

  const [tableData, setTableData] = useState([]);
  const [dataCount, setDataCount] = useState();
  const [offset, setOffset] = useState(1);
  const [scrollLoaderTable, setScrollLoaderTable] = useState(false);
  const tableBodyRef = useRef(null);


  const getCapitalGainReport = async (fileView, offsetTab) => {

    if (fileView === "excel") {
      setSmallLoaderExcel(true);
    }

    if (fileView === "grid" && offsetTab <= 1) {
      setLoader(true);
    }

    let payloadValue = {
      clientCode,
      fileType: fileView,
      pageNo: fileView === "grid" ? offsetTab : -1,
      pageSize: fileView === "grid" ? 10 : -1,
      fromDate,
      endDate: toDate,
    };

    let encPayload = AESEncryption(payloadValue);
    console.log(payloadValue, "capitalgain");
    
    try {
      const getDetails = await axiosInstance.post(
        MFReports.Capital_Gain,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);
      if (res?.status === 0) {
        if (fileView === "grid") {
          setDataCount(res?.data?.totalCount);
          if (offsetTab > 1) {
            setTableData((prev) => {
              return [...prev, ...res?.data?.capitalGainList];
            });
          } else {
            setTableData(res?.data?.capitalGainList);
          }
          setScrollLoaderTable(false);
        } else if (fileView === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        }
      } else {
        setTableData([]);
        if (fileView !== "grid") {
          setErrorGrid(res?.message);
          toast.error(res?.message);
        } else {
          setErrorGrid(res?.message);
        }
      }
    } catch (error) {
      console.log(error);
      setServerError(error?.message);
      if (fileView !== "grid") {
        toast.error(error?.message);
      }
    } finally {
      setLoader(false);
      setSmallLoaderExcel(false);
    }
  };

  const handleOnClick = (e) => {
    setOffset(1);
    if (e.target.value) {
      if (clientCode) {
        getCapitalGainReport(e.target.value, 1);
      } else {
        setTableData([]);
      }
    } else {
      setTableData([]);
    }
  };

  const handleTableScroll = (e) => {
    const el = e.target;
    const scrolledToBottom =
      el.scrollTop + el.offsetHeight + 1 >= el.scrollHeight;

    if (scrolledToBottom && !scrollLoaderTable) {
      const nextOffset = offset + 1;
      const totalLoadedRecords = offset * 10;

      if (dataCount > totalLoadedRecords && dataCount !== tableData?.length) {
        setOffset(nextOffset);
        setScrollLoaderTable(true);
        setLoader(false);
        getCapitalGainReport("grid", nextOffset);
      } else {
        setScrollLoaderTable(false);
      }
    }
  };

  const currFYear = new Date().getFullYear();
  const lastFYear = currFYear - 1;
  const secondLastFYear = currFYear - 2;

  const changeFY = (e) => {
    const val = e.target.value;
    let date = new Date();
    let firstDay = "";
    let lastDay = "";

    if (val == "currYear") {
      let currentFyearStart = new Date(getCurrentFinancialYear(date).startDate);
      let firstVal = new Date(
        currentFyearStart.getFullYear(),
        currentFyearStart.getMonth(),
        1
      );

      firstDay = moment(firstVal, "MM-DD-YYYY").format("YYYY-MM-DD");
      let lastVal = new Date();
      lastDay = moment(lastVal, "MM-DD-YYYY").format("YYYY-MM-DD");
      setFromDate(firstDay);
      setToDate(lastDay);
    } else if (val == "lastYear") {
      let currentFyearStart = new Date(getCurrentFinancialYear(date).startDate);
      let currentFyearEnd = new Date(getCurrentFinancialYear(date).endDate);
      let firstVal = new Date(
        currentFyearStart.getFullYear() - 1,
        currentFyearStart.getMonth(),
        1
      );
      firstDay = moment(firstVal, "MM-DD-YYYY").format("YYYY-MM-DD");
      let lastVal = new Date(
        currentFyearEnd.getFullYear() - 1,
        currentFyearEnd.getMonth(),
        31
      );
      lastDay = moment(lastVal, "MM-DD-YYYY").format("YYYY-MM-DD");

      setFromDate(firstDay);
      setToDate(lastDay);
    } else if (val == "secondLastYear") {
      let currentFyearStart = new Date(getCurrentFinancialYear(date).startDate);
      let currentFyearEnd = new Date(getCurrentFinancialYear(date).endDate);
      let firstVal = new Date(
        currentFyearStart.getFullYear() - 2,
        currentFyearStart.getMonth(),
        1
      );
      firstDay = moment(firstVal, "MM-DD-YYYY").format("YYYY-MM-DD");
      let lastVal = new Date(
        currentFyearEnd.getFullYear() - 2,
        currentFyearEnd.getMonth(),
        31
      );
      lastDay = moment(lastVal, "MM-DD-YYYY").format("YYYY-MM-DD");
      setFromDate(firstDay);
      setToDate(lastDay);
    } else {
      setFromDate("");
      setToDate("");
    }
  };

  // useEffect(() => {
  //   const el = tableBodyRef.current;
  //   if (!el) return;
  //   const checkScroll = () => {
  //     setHasVerticalScroll(el.scrollHeight > el.clientHeight);
  //   };
  //   checkScroll();
  //   const observer = new ResizeObserver(checkScroll);
  //   observer.observe(el);
  //   return () => observer.disconnect();
  // }, [tableData]);


  return (
    <>
      <Header portal={"RM"} />
      <SingleSignOnSideBar />
      <main id="main-content" className="reports">
        <div className="card-box">
          <div>
            <h2 className="report-title">MF Capital Gain Report</h2>
          </div>
          <div className="row input-field-wrapper">
            <div className="col-md-3 col-sm-3 col-6">
              <CommonSearch setDataCount={setDataCount}
              setClientCode={setClientCode}
              clientCode={clientCode} />
            </div>
            <div className="col-md-3 col-sm-3 col-6">
              <div className="form-group">
                <label className="form-label">Select Financial Year</label>
                <select onChange={changeFY} className="report-custom-select">
                  <option value="currYear">{"FY " + currFYear}</option>
                  <option value="lastYear">{"FY " + lastFYear}</option>
                  <option value="secondLastYear">
                    {"FY " + secondLastFYear}
                  </option>
                </select>
              </div>
            </div>

          </div>


          <div className="text-center search-btn-wrapper">
            <button
              value="grid"
              className="send-message"
              onClick={handleOnClick}
              disabled={loader || !clientCode}
            >
              {Constants.Search}
            </button>
          </div>
          <div>
            <ReportTableHeader
              showEmailBtn={false}
              showPdfBtn={false}
              smallLoaderExcel={smallLoaderExcel}
              handleOnClick={handleOnClick}
            />
          </div>
          <div className="for-grid-section pnl-wrapper">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) :
              tableData && tableData?.length > 0 ? (
                <MFCapitalGainReportTable
                  tableData={tableData}
                  handleTableScroll={handleTableScroll}
                  // hasVerticalScroll={hasVerticalScroll}
                  scrollLoaderTable={scrollLoaderTable}
                  loader={loader}
                  LoaderForSearch={LoaderForSearch}
                  ref={tableBodyRef}
                  clientDashboard={true}
                />
              ) : serverError ? (
                <h4 className="report-error-message">{noDataFound(serverError)}</h4>
              ) : errorGrid && (
                noDataFound(errorGrid)
              )}
          </div>
        </div>
      </main >
    </>
  );
}

export default MfCapitalGainReportSidebar;
